import { type OrderingCart } from '@order/features/ordering';

/**
 * The submission input is different from the cart response.
 * This converts the response into the input.
 */
export const getDeliveryParams = (
  orderChannel: OrderingCart['orderChannel'],
  selectedTip: number,
  deliveryOrderDetail: OrderingCart['deliveryOrderDetail'],
) => {
  return orderChannel === 'delivery' && deliveryOrderDetail?.address?.id
    ? {
        addressId: deliveryOrderDetail.address.id,
        deliveryFee: deliveryOrderDetail.deliveryFee,
        vendor: deliveryOrderDetail.vendor,
        vendorRestaurantId: deliveryOrderDetail.vendorRestaurantId,
        tip: selectedTip,
      }
    : undefined;
};
